import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const ProtectedRoute = ({ children, requiredRole = null, allowFirstLogin = false }) => {
  const { isAuthenticated, hasRole, needsFirstLogin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated()) {
    // Redirect to login page with return url
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user needs to complete first-login (unless this route allows it)
  if (needsFirstLogin() && !allowFirstLogin) {
    // User needs to complete first-login, redirect to first-login page
    return <Navigate to="/first-login" replace />;
  }

  if (requiredRole && !hasRole(requiredRole)) {
    // User doesn't have required role, redirect to dashboard
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;